import Api from '@/services/Api'

export default {
    leaCompania(){
        return Api().get('leaCompania')
    },
    leaCompaniaMunicipios(){
        return Api().get('leaCompaniaMunicipios')
    },
    leaCompaniaCiius(){
        return Api().get('leaCompaniaCiius')
    },
    leaCompaniaMunicipiosCiius(){
        return Api().get('leaCompaniaMunicipiosCiius')
    },
}
